import React from 'react';

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
}

const Box: React.FC<BoxProps> = ({ className = '', children, ...props }) => (
  <div {...props} className={`${className} box`}>
    {children}
  </div>
);

export default Box;
